import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {FormControl, Grow, SelectChangeEvent, Typography} from "@mui/material";
import TextinputField from "../../CommonComponents/TextInputField/TextinputField";
import StyledTextarea from "../../CommonComponents/StyledTextarea/StyledTextarea";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import StyledDataTimePicker from "../../CommonComponents/StyledDateTimePicker/StyledDataTimePicker";
import StyledAutocomplete from "../../CommonComponents/StyledAutocomplete/StyledAutocomplete";
import StyledDropdown from "../../CommonComponents/StyledDropdown/StyledDropdown";
import TransparentButton from "../../CommonComponents/TransparentButton/TransparentButton";
import React, {startTransition, Suspense, useEffect, useRef, useState} from "react";
import {useTheme} from "../../../contexts/theme";
import dayjs, {Dayjs} from "dayjs";

import {
    AdditionalProps,
    DataFeed,
    DataSource,
    FileDataSource,
    Ftp,
    MatchesFTP,
    MediaContainer,
    Stream,
    Track
} from "../../../types/dataSourceTypes";
import DataSourceForm from "./DataSourceForm";
import StyledSwitch from "../../CommonComponents/StyledSwitch/StyledSwitch";
import axios from "../../../queries/axiosInstance";
import StyledChip from "../../CommonComponents/StyledChip/StyledChip";
import {formatLabel} from "../../../utils/utils";
import ErrorSnackBar from "../../CommonComponents/ErrorSnackBar/ErrorSnackBar";
import {LoadError} from "../../../types/generic";
import {defaultEvent, EventBasketData, EventData, GenericEventData} from "../../../types/eventTypes";
import SpinnerBox from "../../CommonComponents/SpinnerBox/SpinnerBox";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;
import change = Simulate.change;

const LazyFootballForm = React.lazy(() => import("./FootballForm"));
const LazyBasketForm = React.lazy(() => import("./BasketForm"));

interface EventFormProps {
    entity: GenericEventData,
    onSubmit: (data: EventData | EventBasketData, mode: "create" | "update") => void;
    optionsForm?: {
        optionsTag: string[];
        protocol: string[];
        typeMediaTrack: string[];
        typeOfFile: string[];
        containerType: string[];
        typeEvent: "football";
        typeProviderDataFeed: string[];
        feedSourcesTypes: string [];
        feed_type: string[];
    }
    mode : "update" | "create";
    openForm: boolean;

}







export default function EventForm({
                                      entity,
                                      onSubmit,
                                      optionsForm,
                                        mode,
                                        openForm
                                  }: EventFormProps) {





    const [loadError, setLoadError] = useState<LoadError>({error: false, message: ''});


    const [matchesFTP, setMatchesFTP] = useState<MatchesFTP[]>([]);
    const theme = useTheme();
    const [showForm, setShowForm] = useState(false);


    // Quando openForm cambia, usa startTransition per mostrare il form in modo asincrono
    useEffect(() => {
        if (openForm) {
            startTransition(() => {
                setShowForm(true);
            });
        } else {
            setShowForm(false);
        }
    }, [openForm]);






    const handleChangeError = (error: boolean, message: string) => {
        setLoadError({ error: error, message: message });
    }








    return (
        <>

            <Box sx={{
                justifyContent: 'center',
                alignItems: 'center',
                padding: theme.spacing.md,
            }}>
                <ErrorSnackBar autoHideDuration={5000} open={loadError.error}
                               setClose={() => setLoadError({message: '', error: false})}
                               errorMessage={loadError.message}/>


                <form>

                        {process.env.REACT_APP_SPORT === "football" && showForm ? (
                            <LazyFootballForm
                                onSubmit={onSubmit}
                                openForm={openForm}
                                mode={mode}
                                loadError={loadError}
                                handleChangeError={handleChangeError}
                                entity={entity}
                            />
                        ) : showForm && (
                            <LazyBasketForm
                                onSubmit={onSubmit}
                                openForm={openForm}
                                mode={mode}
                                loadError={loadError}
                                handleChangeError={handleChangeError}
                                entity={entity}
                            />
                        )}

                </form>


            </Box>

        </>

    )
}